import Swiper, { A11y, Navigation, Pagination, Autoplay, Keyboard } from 'swiper';

Swiper.use( [ A11y, Navigation, Pagination, Autoplay, Keyboard ] );

let toFade = undefined;


let skippedInit = false;


// Themes
const sliderThemes = new Swiper( '[data-slider="themes"]', {
    observer                : true,
    observeParents          : true,
    loop                    : false,
    initialSlide            : thematiqueSliderInitialIndex(),
    grabCursor              : true,
    preventClicksPropagation: false,
    threshold               : 20, // Fallback to prevent slide on click
    breakpoints             : {
        768 : {
            threshold      : 100, // Fallback to prevent slide on click
            longSwipesRatio: 1,
        },
        1024: {
            threshold: 200, // Fallback to prevent slide on click
        },
    },
    debounceIn              : null,
    debounceOut             : null,
    keyboard                : {
        enabled: true,
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    on        : {
        afterInit                 : function ()
        {
            toFade = document.querySelectorAll( '.swiper-button-prev, .swiper-button-next, .site-header' );
            toFade.forEach( elem => elem.classList.remove( "fade" ) );


            toFade.forEach( elem => elem.classList.remove( "fade" ) );
        },
        slideChange               : function ( swiper )
        {

            const activeSlide     = swiper.slides[ swiper.activeIndex ];
            const activeSlideSlug = activeSlide?.dataset?.slug ?? null;
                skippedInit = true;

            // Fallback because on init, Swiper force the slide to 1 and trigger an on change
            if ( !skippedInit ) {
            }
            else if ( activeSlideSlug ) {
                document.location.hash = activeSlideSlug;
            }
        },
        slideChangeTransitionStart: function ()
        {
            if ( toFade === undefined ) {
                return;
            }

            toFade.forEach( elem => elem.classList.add( "fade" ) );
        },
        slideChangeTransitionEnd  : function ()
        {
            if ( toFade === undefined ) {
                return;
            }

            toFade.forEach( elem => elem.classList.remove( "fade" ) );
        },
    },
} );

// Selection - Collage

let currentItemDrag = null;
let currentOffset   = { x: 0, y: 0 };
let startPosition   = { x: 0, y: 0 };

const sliderSelection = new Swiper( '[data-slider="selection"]', {
    loop                    : true,
    observer                : true,
    grabCursor              : true,
    preventClicksPropagation: false,
    freeMode                : true,
    allowTouchMove          : false,
    slidesPerView           : 2,
    breakpoints             : {
        400 : {
            slidesPerView: 3,
        },
        768 : {
            slidesPerView: 4,
            threshold    : 200, // Fallback to prevent slide on click
        },
        1024: {
            slidesPerView: 5,
            grabCursor   : false,
        },
    },
    debounceIn              : null,
    debounceOut             : null,
    keyboard                : {
        enabled: true,
    },
    navigation              : {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    on                      : {
        slideChange: function ()
        {
            //
        },

        //touchStart: (swiper, event) => startDragItem(swiper, event),
        // touchMove: (swiper, event) => dragItem(swiper, event),
        // touchMoveOpposite: (swiper, event) => dragItem(swiper, event),
        // touchEnd: (swiper, event) => endDragItem(swiper, event)
    },
} );


function thematiqueSliderInitialIndex()
{
    let sliderIndex = 0;

    if ( window.location.hash.length > 0 ) {
        const sliderHash        = window.location.hash.substring( 1 );
        const slides            = [ ...document.querySelectorAll( '[data-slider="themes"] .swiper-slide' ) ];
        // const hashMatchingSlide = slides.find( slide => slide?.dataset?.slug ?? false );

        for ( let i = 0; i < slides.length; i++ ) {

            const slide = slides[i];
            const slug = slide?.dataset?.slug ?? false;

            if(slug === sliderHash) {
                sliderIndex = i;
                break;
            }
        }

    }
    else {
        const sliderContainer = document.querySelector( '[data-slider="themes"]' );

        if ( sliderContainer &&
             typeof sliderContainer.dataset !==
             'undefined' &&
             typeof sliderContainer.dataset.startingIndex !==
             'undefined' ) {

            sliderIndex = parseInt( sliderContainer.dataset.startingIndex ?? 0 );
        }
    }

    return sliderIndex;
}
